import '../styles/Demand.css';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Collection }             from '@mathquis/modelx';
import { Button }                 from 'antd';
import { List }                   from 'antd';
import { withNavigation }         from 'components/App/withNavigation';
import { WithNavigationProps }    from 'components/App/withNavigation';
import dayjs                      from 'dayjs';
import React                      from 'react';
import { observer }               from 'mobx-react';
import { Col }                    from 'antd';
import { NavLink }                from 'react-router-dom';
import { computed }               from 'mobx';
import { notification }           from 'antd';
import { Modal }                  from 'antd';
import { Skeleton }               from 'antd';
import { EditOutlined }           from '@ant-design/icons';
import { DownloadOutlined }       from '@ant-design/icons';
import { DeleteOutlined }         from '@ant-design/icons';
import CardBox                    from 'components/App/CardBox';
import Row                        from 'components/App/Row';
import { appStore }               from 'stores/AppStore';
import { privateLayoutStore }     from 'stores/index';
import currentSession             from 'utils/currentSession';
import { messageErrorIntl }       from 'utils/messageIntl';
import { formatMessageIntl }      from 'utils/messageIntl';
import rights                     from 'utils/rights';
import FormattedMessageWrapper    from 'components/App/FormattedMessageWrapper';
import DemandModel                from 'models/DemandModel';
import DemandStatusModel          from 'models/DemandStatusModel';
import DemandTypeModel            from 'models/DemandTypeModel';
import DropDownMenu               from 'components/App/DropDownMenu';
import GridInfo                   from 'components/App/GridInfo';
import { MODE_VIEW }              from 'forms/StandistForm/StandistForm';
import DemandMessageListBox       from '../components/DemandMessageListBox';
import { ApiCollection }          from 'collections/ApiCollection';
import DemandMessageModel         from 'models/DemandMessageModel';
import MessageModel               from 'models/MessageModel';
import { PagedCollection }        from 'collections/PagedCollection';
import MessageMediaModel          from 'models/MessageMediaModel';
import DemandStatus               from '../components/DemandStatus';
import {
  ROLE_STANDIST_AGENCY,
  ROLE_STANDIST_DECORATOR,
  ROLE_STANDIST_EXHIBITOR,
}                                 from 'constants/StandistRoleReference';
import UserModel                  from 'models/UserModel';
import UserStandRoleModel         from 'models/UserStandRoleModel';
import DemandMessageMediaListBox  from '../components/DemandMessageMediaListBox';
import DemandLogisticModel        from 'models/DemandLogisticModel';
import DemandLogisticBox          from '../components/DemandLogisticBox';
import DemandExemptionForm        from 'forms/DemandExemptionForm';
import DemandLogisticForm         from 'forms/DemandLogisticForm';
import {
  EXEMPTION_DELIVERY,
  EXEMPTION_DISMANTLING,
  EXEMPTION_MOUNTING,
}                                 from 'constants/DemandTypes';
import handleApiError             from 'utils/handleApiError';
import DemandMediaModel           from 'models/DemandMediaModel';
import { downloadFileFromBlob }   from 'utils/downloadFile';
import { IN_PROGRESS, VALIDATED } from 'constants/DemandStatuses';
import {
  AgencyStandists,
  DecoratorStandists,
  ExhibitorStandists,
}                                 from 'components/App/StandistStandists';
import { MODE_EDIT }              from 'forms/StandistForm/StandistForm';
import DemandPdfModel             from 'models/DemandPdfModel';
import DashboardComponent         from 'components/App/DashboardComponent';
import DemandLogisticMediaModel   from 'models/DemandLogisticMediaModel';
import DemandConfigModel          from 'models/DemandConfigModel';
import PageTitle                  from 'components/App/PageTitle';
import ShowModel                  from 'models/ShowModel';
import StandModel                 from 'models/StandModel';
import { AppForm }                from 'components/App/AppForm';

const HeadTitle = observer(({
  demand,
  demandType,
}: {
  demand: DemandModel;
  demandType: DemandTypeModel;
}) => {
  if (demand.isLoading || demandType.isLoading) {
    return <Skeleton />;
  }

  return (
    <div style={{ fontWeight: 'bold' }}>
      <FormattedMessageWrapper
        id="- Demande de dérogation -"
        values={{
          demandId: demand.formattedId,
          demandTypeLabel: demandType.label,
        }}
      />
    </div>
  );
});

const HeadContent = observer(({
  agencyVirtualCollection,
  decoratorVirtualCollection,
  demand,
  demandLogistic,
  demandStatusCollection,
  exhibitorVirtualCollection,
  fetchStandistsWithRoles,
  show,
  stand,
  userStandRoleCollection,
}: {
  agencyVirtualCollection: Collection<UserModel>;
  decoratorVirtualCollection: Collection<UserModel>;
  demand: DemandModel;
  demandLogistic?: DemandLogisticModel;
  demandStatusCollection: ApiCollection;
  exhibitorVirtualCollection: Collection<UserModel>;
  fetchStandistsWithRoles: () => void;
  show: ShowModel;
  stand: StandModel;
  userStandRoleCollection: ApiCollection<UserStandRoleModel>;
}) => {
  const demandStatus = demandStatusCollection.findBy('id', demand.demandStatusId) as DemandStatusModel;
  const isValidated = demandStatus && demandStatus.reference === VALIDATED;

  const dataFirstCol = [
    {
      label: <FormattedMessageWrapper id="Demandeur" />,
      value: demand.fullName,
    },
  ];

  if (demandLogistic && demandLogistic.id) {
    dataFirstCol.push(
      {
        label: isValidated ? (
          <FormattedMessageWrapper id="Date de livraison validée" />
        ) : (
          <FormattedMessageWrapper id="Date de livraison souhaitée" />
        ),
        value: demand.askedDatetimeDate?.format('L') ?? '',
      },
      {
        label: isValidated ? (
          <FormattedMessageWrapper id="Heure de livraison validée" />
        ) : (
          <FormattedMessageWrapper id="Heure de livraison souhaitée" />
        ),
        value: demand.askedDatetimeDate?.format('HH[h]mm') ?? '',
      },
      {
        label: isValidated ? (
          <FormattedMessageWrapper id="Date d'enlèvement validée" />
        ) : (
          <FormattedMessageWrapper id="Date d'enlèvement souhaitée" />
        ),
        value: demandLogistic.pickupDatetimeDate?.format('L') ?? '',
      },
      {
        label: isValidated ? (
          <FormattedMessageWrapper id="Heure d'enlèvement validée" />
        ) : (
          <FormattedMessageWrapper id="Heure d'enlèvement souhaitée" />
        ),
        value: demandLogistic.pickupDatetimeDate?.format('HH[h]mm') ?? '',
      },
    );
  } else {
    dataFirstCol.push(
      {
        label: isValidated ? (
          <FormattedMessageWrapper id="Date validée" />
        ) : (
          <FormattedMessageWrapper id="Date souhaitée" />
        ),
        value: demand.askedDatetimeDate?.format('L') ?? '',
      },
      {
        label: isValidated ? (
          <FormattedMessageWrapper id="Heure validée" />
        ) : (
          <FormattedMessageWrapper id="Heure souhaitée" />
        ),
        value: demand.askedDatetimeDate?.format('HH[h]mm') ?? '',
      },
    );
  }

  const data = [
    // dataFirstCol,
    [
      {
        label: <FormattedMessageWrapper id="Stand" />,
        value: <NavLink to={`/stands/${stand.id}`}>{stand.name}</NavLink>,
      },
      {
        label: <FormattedMessageWrapper id="Surface du stand" />,
        value: `${stand.surface} m2`,
      },
      {
        label: <FormattedMessageWrapper id="Type" />,
        value: stand.standType,
      },
    ],
    [
      {
        label: <FormattedMessageWrapper id="Hall" />,
        value: stand.hall,
      },
      {
        label: <FormattedMessageWrapper id="Allée" />,
        value: stand.aisle,
      },
      {
        label: <FormattedMessageWrapper id="Numéro" />,
        value: stand.number,
      },
    ],
    [
      {
        label: <FormattedMessageWrapper id="Exposant(s)" />,
        value: (
          <ExhibitorStandists
            externalSync={show.externalSync}
            mode={rights.for.userStandRole.edit ? MODE_EDIT : MODE_VIEW}
            onSuccess={fetchStandistsWithRoles}
            stand={stand}
            standistCollection={exhibitorVirtualCollection as ApiCollection<UserModel>}
            userStandRoleCollection={userStandRoleCollection}
          />
        ),
      },
      {
        label: <FormattedMessageWrapper id="Décorateur(s)" />,
        value: (
          <DecoratorStandists
            externalSync={show.externalSync}
            mode={rights.for.userStandRole.edit ? MODE_EDIT : MODE_VIEW}
            onSuccess={fetchStandistsWithRoles}
            stand={stand}
            standistCollection={decoratorVirtualCollection as ApiCollection<UserModel>}
            userStandRoleCollection={userStandRoleCollection}
          />
        ),
      },
      {
        label: <FormattedMessageWrapper id="Agence(s)" />,
        value: (
          <AgencyStandists
            externalSync={show.externalSync}
            mode={rights.for.userStandRole.edit ? MODE_EDIT : MODE_VIEW}
            onSuccess={fetchStandistsWithRoles}
            stand={stand}
            standistCollection={agencyVirtualCollection as ApiCollection<UserModel>}
            userStandRoleCollection={userStandRoleCollection}
          />
        ),
      },
    ],
  ];

  return (
    <Row>
      <Col span={8}>
        <GridInfo data={[dataFirstCol]} />
      </Col>
      <Col span={16}>
        <GridInfo data={data} />
      </Col>
    </Row>
  );
});

@observer
class DemandDashboard extends React.Component<WithNavigationProps> {
  public demand = new DemandModel();
  public demandConfigCollection = new ApiCollection(DemandConfigModel);

  public demandLogisticCollection = new ApiCollection(DemandLogisticModel);
  public demandLogisticMediaCollection = new ApiCollection(DemandLogisticMediaModel);
  public demandMediaCollection = new ApiCollection(DemandMediaModel);
  public demandMessagePagedCollection = new PagedCollection(DemandMessageModel);
  public demandStatusCollection = new ApiCollection(DemandStatusModel);
  public demandTypeCollection = new ApiCollection(DemandTypeModel);
  public messageCollection = new ApiCollection(MessageModel);
  public messageMediaCollection = new ApiCollection(MessageMediaModel);
  public show = new ShowModel();
  public stand = new StandModel();
  public standistCollection = new ApiCollection(UserModel);
  public userStandRoleCollection = new ApiCollection(UserStandRoleModel);

  public agencyVirtualCollection = this.standistCollection.createVirtualCollection(
    (user: UserModel) =>
      !!this.userStandRoleCollection.find(
        (userStandRole: UserStandRoleModel) =>
          userStandRole.userIri === user.iri &&
          userStandRole.standistRole === ROLE_STANDIST_AGENCY,
      ),
  );

  public decoratorVirtualCollection = this.standistCollection.createVirtualCollection(
    (user: UserModel) =>
      !!this.userStandRoleCollection.find(
        (userStandRole: UserStandRoleModel) =>
          userStandRole.userIri === user.iri &&
          userStandRole.standistRole === ROLE_STANDIST_DECORATOR,
      ),
  );

  public exhibitorVirtualCollection = this.standistCollection.createVirtualCollection(
    (user: UserModel) =>
      !!this.userStandRoleCollection.find(
        (userStandRole: UserStandRoleModel) =>
          userStandRole.userIri === user.iri &&
          userStandRole.standistRole === ROLE_STANDIST_EXHIBITOR,
      ),
  );

  public state = {
    dataLoading: false,
  };

  constructor(props: WithNavigationProps) {
    super(props);

    this.demandMessagePagedCollection.itemsPerPage = 50;
  }

  public async componentDidMount() {
    await this.fetchData();

    try {
      await privateLayoutStore.setCurrentShowId(this.show.id);
    } catch (error: any) {
      if (error.name === 'show_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_show_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }

    await Promise.all([
      this.demandStatusCollection.list(),
      this.demandTypeCollection.list(),
    ]);
  }

  public async componentDidUpdate(prevProps: WithNavigationProps) {
    if (prevProps.params !== this.props.params) {
      await this.fetchData();

      try {
        await privateLayoutStore.setCurrentShowId(this.show.id);
      } catch (error: any) {
        if (error.name === 'show_not_found') {
          this.props.navigate('/404');
        }

        if (error.name === 'get_show_unauthorized') {
          this.props.navigate('/erreur');
        }
      }
    }
  }

  public render() {
    return (
      <>
        <PageTitle title={<FormattedMessageWrapper id="Tableau de bord de la demande" />} />

        <DashboardComponent
          body={this.renderBody()}
          dataLoading={this.state.dataLoading}
          headContent={this.renderHeadContent()}
          model={this.demand}
          title={this.renderTitle()}
          topRightComponent={this.renderTopRightComponent()}

        />
      </>
    );
  }

  public renderBody = () => (
    <Row>
      <Col md={16} sm={24}>
        <Row>
          {this.demandLogistic.id && (
            <Col span={24}>
              <DemandLogisticBox
                demand={this.demand}
                demandLogistic={this.demandLogistic}
                demandTypeCollection={this.demandTypeCollection}
              />
              <br />
            </Col>
          )}

          <Col span={24}>
            <DemandMessageListBox
              demand={this.demand}
              demandLogistic={this.demandLogistic}
              demandLogisticCollection={this.demandLogisticCollection}
              demandMessagePagedCollection={this.demandMessagePagedCollection}
              demandStatusCollection={this.demandStatusCollection}
              fetchMessages={this.fetchMessages}
              messageCollection={this.messageCollection}
              messageMediaCollection={this.messageMediaCollection}
              openDemandFormModal={this._openDemandFormModal}
              show={this.show}
            />
          </Col>
        </Row>
      </Col>
      <Col md={8} sm={24}>
        <Row>
          <Col span={24}>
            <DemandMessageMediaListBox
              demandLogisticMediaCollection={this.demandLogisticMediaCollection}
              messageMediaCollection={this.messageMediaCollection}
            />
          </Col>
          <Col span={24}>
            <CardBox
              bodyStyle={{ padding: 0 }}
              content={(
                <List
                  dataSource={[ this.demand, ]}
                  locale={{
                    emptyText: <FormattedMessageWrapper id="Aucun fichier." />,
                  }}
                  pagination={false}
                  renderItem={(item: DemandModel) => (
                    <List.Item key={item.id}>
                      <List.Item.Meta title={<FormattedMessageWrapper id="Fiche de la demande" />} />

                      <Button
                        icon={<DownloadOutlined />}
                        onClick={() => this.downloadDemandPdf(this.demand.id, appStore.locale)}
                        style={{
                          alignItems: 'center',
                          display: 'flex',
                          gap: '8px',
                        }}
                      >
                        <FormattedMessageWrapper id="Télécharger" />
                      </Button>
                    </List.Item>
                  )}
                  size="large"
                />

              )}
              title={<FormattedMessageWrapper id="Dérogation" />}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );

  public renderHeadContent = () => {
    return (
      <HeadContent
        agencyVirtualCollection={this.agencyVirtualCollection}
        decoratorVirtualCollection={this.decoratorVirtualCollection}
        demand={this.demand}
        demandLogistic={this.demandLogistic}
        demandStatusCollection={this.demandStatusCollection}
        exhibitorVirtualCollection={this.exhibitorVirtualCollection}
        fetchStandistsWithRoles={this.fetchStandistsWithRoles}
        show={this.show}
        stand={this.stand}
        userStandRoleCollection={this.userStandRoleCollection}
      />
    );
  };

  public renderTitle = () => <HeadTitle demand={this.demand} demandType={this.demandType} />;

  public renderTopRightComponent = () => {
    const demandStatusInProgress = this.demandStatus.reference === IN_PROGRESS;

    const items = [
      {
        disabled: !demandStatusInProgress,
        icon: <EditOutlined />,
        key: 'UPDATE',
        label: <FormattedMessageWrapper id="Modifier la demande" />,
        onClick: this._openDemandFormModal,
      },
      {
        icon: <DownloadOutlined />,
        key: `DOWNLOAD_SHEET`,
        label: <FormattedMessageWrapper id="Télécharger la fiche" />,
        onClick: () => this.downloadDemandPdf(this.demand.id, appStore.locale),
      },
      {
        // danger: true,
        disabled: !demandStatusInProgress,
        icon: <DeleteOutlined />,
        key: 'DELETE',
        label: <FormattedMessageWrapper id="Supprimer la demande" />,
        onClick: () => {
          Modal.confirm({
            content: formatMessageIntl("Confirmez-vous cette suppression ?"),
            icon: <QuestionCircleOutlined style={{ color: '#e74c3c' }} />,
            okText: formatMessageIntl("Supprimer"),
            onOk: async () => {
              try {
                await this.demand.destroy();

                notification.success({
                  message: formatMessageIntl("Suppression réussie !"),
                });

                this.props.navigate(`/stands/${this.stand.id}`);
              } catch (error) {
                handleApiError(error);
              }
            },
            title: formatMessageIntl("Suppression"),
          });
        },
      },
    ];

    return (
      <div style={{ alignItems: 'center', display: 'flex' }}>
        <div>
          <DemandStatus demand={this.demand} demandStatusCollection={this.demandStatusCollection} />
        </div>
        <div>
          <DropDownMenu items={items} />
        </div>
      </div>
    );
  };

  private demandSeen = async () => {
    if (currentSession.isAdminOrSupport && this.demand?.unSeen) {
      await this.demand.patch({ unSeen: false });
    }
  };

  private downloadDemandPdf = async (id: id, locale: string) => {
    this.setState({ dataLoading: true });

    const demandPdf = new DemandPdfModel();
    demandPdf.set({ id, locale });

    try {
      const response = await demandPdf.fetch();

      const blob = new Blob([response.data], { type: 'application/pdf' });

      const time = dayjs().format('YYYY-MM-DD_HHmm');

      const filename = `${[this.show.showName, this.stand.name, this.demand.formattedId, time].join(
        '_',
      )}.pdf`;

      downloadFileFromBlob(blob, filename);
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }

    this.setState({ dataLoading: false });
  };

  private fetchData = async () => {
    const { id } = this.props.params;

    this.demand.set('id', id);

    try {
      await this.demand.fetch();
    } catch (error: any) {
      const requestStatus = error?.connectorError?.request?.status || error?.connectorError?.response?.status;

      if (requestStatus === 401) {
        this.props.navigate('/logout');
      } else if (requestStatus === 404 || requestStatus === 405) {
        this.props.navigate('/404');
      } else {
        this.props.navigate('/erreur');
      }

      return;
    }

    await Promise.all([
      this.demandType.set('id', this.demand.demandTypeId).fetch(),

      this.demandMediaCollection.setFilter('demand', this.demand.id).list(),

      this.demandLogisticCollection.setFilter('demand', this.demand.id).list(),

      this.demandLogisticMediaCollection.setFilter('demandLogistic.demand', this.demand.id).list(),

      this.stand
        .set('id', this.demand.standId)
        .fetch()
        .then(async () => {
          // setCurrentShowId for PrivateLayout
          try {
            await privateLayoutStore.setCurrentShowId(this.stand.showId);
          } catch (error: any) {
            if (error.name === 'show_not_found') {
              this.props.navigate('/404');
            }

            if (error.name === 'get_show_unauthorized') {
              this.props.navigate('/erreur');
            }

            return;
          }

          await Promise.all([
            this.show.set('id', this.stand.showId).fetch(),

            this.demandConfigCollection.setFilter('show', this.stand.showId).list(),
          ]);
        }),

      this.fetchMessages(),

      this.fetchStandistsWithRoles(),
    ]);

    // await for dataLoading at the end
    await this.demandSeen();
  };

  private fetchMessages = async () => {
    await this.demandMessagePagedCollection
      .setFilter('demand', this.demand.id)
      .setSorts({
        'message.createdAt': false,
        'message.id': false,
      })
      .list();

    const messagesIds = this.demandMessagePagedCollection.getUniques('message.id');

    if (messagesIds.length) {
      await Promise.all([
        this.messageCollection.setFilter('id', messagesIds).list(),

        this.messageMediaCollection.setFilter('message', messagesIds).list(),
      ]);
    }
  };

  private fetchStandistsWithRoles = async () => {
    await this.userStandRoleCollection.setFilter('stand', this.demand.standId).list();

    const usersIris = this.userStandRoleCollection.getUniques('user');

    await this.standistCollection.setFilter('id', usersIris).list();
  };

  @computed
  public get demandLogistic(): DemandLogisticModel {
    if (!this.demandLogisticCollection.length) {
      return new DemandLogisticModel();
    }

    return this.demandLogisticCollection.first() as DemandLogisticModel;
  }

  @computed
  public get demandLogisticMediaDocument(): DemandLogisticMediaModel {
    const demandLogisticMediaPlan = this.demandLogisticMediaCollection.findBy('type', 'document') as DemandLogisticMediaModel;

    if (!demandLogisticMediaPlan) {
      return new DemandLogisticMediaModel();
    }

    return demandLogisticMediaPlan;
  }

  @computed
  public get demandLogisticMediaPlan(): DemandLogisticMediaModel {
    const demandLogisticMediaPlan = this.demandLogisticMediaCollection.findBy('type', 'plan') as DemandLogisticMediaModel;

    if (!demandLogisticMediaPlan) {
      return new DemandLogisticMediaModel();
    }

    return demandLogisticMediaPlan;
  }

  @computed
  public get demandStatus(): DemandStatusModel {
    const demandStatus = this.demandStatusCollection.findBy(
      'id',
      this.demand.get('demandStatus.id'),
    ) as DemandStatusModel;

    if (!demandStatus) {
      return new DemandStatusModel();
    }

    return demandStatus;
  }

  @computed
  public get demandType(): DemandTypeModel {
    const demandType = this.demandTypeCollection.findBy('id', this.demand.get('demandType.id')) as DemandTypeModel;

    if (!demandType) {
      return new DemandTypeModel();
    }

    return demandType;
  }

  private _openDemandFormModal = () => {
    const demandConfig = this.demandConfigCollection.findBy(
      'demandType',
      this.demand.demandTypeIri,
    ) as DemandConfigModel;

    const title = <FormattedMessageWrapper id="Modifier la demande" />;

    const isExemption = [EXEMPTION_DISMANTLING, EXEMPTION_MOUNTING, EXEMPTION_DELIVERY].find(
      e => e === this.demandType.reference,
    );

    if (isExemption) {
      AppForm.open(DemandExemptionForm, {
        demandConfigs: [demandConfig],
        model: this.demand,
        onSuccess: () => {
          notification.success({
            title: formatMessageIntl("Modification réussie !"),
          });
        },
        stand: this.stand,
      },
      {
        title,
      });
    } else {
      AppForm.open(DemandLogisticForm, {
        demandConfigs: [demandConfig],
        demandLogistic: this.demandLogistic,
        demandLogisticMediaDocument: this.demandLogisticMediaDocument,
        demandLogisticMediaPlan: this.demandLogisticMediaPlan,
        model: this.demand,
        onSuccess: () => {
          notification.success({
            title: formatMessageIntl("Modification réussie !"),
          });

          this.demandMediaCollection.list();
          this.demandLogisticMediaCollection.list();
        },
        stand: this.stand,
      },
      {
        title,
      });
    }
  };
}

const WrappedDemandDashboard = withNavigation(DemandDashboard);

export default WrappedDemandDashboard;